import React from "react";
import ContentPage, { Block, BulletList } from "../components/ContentPage";

const COUNTRIES = [
  "Nederland",
  "België",
  "Frankrijk",
  "Duitsland",
  "Spanje",
  "Italië",
  "Luxemburg",
  "Zwitserland",
  "Oostenrijk",
  "Het Verenigd Koninkrijk",
  "Andere Europese landen",
];

export default function EuropaPage() {
  return (
    <ContentPage
      title="Bestellen vanuit heel Europa"
      lead="Suriwebwinkel maakt het mogelijk om vanuit verschillende Europese landen een bestelling te plaatsen voor bezorging in Suriname."
      ctaLabel="Start met bestellen"
      secondaryLabel="Veelgestelde vragen"
      secondaryTo="/faq"
    >
      <Block title="Beschikbaar vanuit onder andere">
        <BulletList items={COUNTRIES} />
        <p>
          Tijdens het afrekenen zie je welke betaalmogelijkheden beschikbaar
          zijn voor jouw land.
        </p>
      </Block>

      <Block title="Bezorging in Suriname">
        <p>
          Wij bezorgen lokaal in Suriname bij de ontvanger die jij opgeeft.
          Tijdens het bestellen kun je controleren of het adres binnen ons
          bezorggebied valt. De verwachte bezorgperiode wordt tijdens het
          bestellen weergegeven.
        </p>
      </Block>

      <Block title="Een bestelling plaatsen in je eigen taal">
        <p>
          Suriwebwinkel wil bestellen zo toegankelijk mogelijk maken voor
          klanten in verschillende Europese landen. Onze website is beschikbaar
          in het Nederlands en Engels. Meer talen volgen.
        </p>
      </Block>
    </ContentPage>
  );
}
